import React from 'react';
import Figure from '../components/Figure';
import ExImg from '../logo.svg';

export default function Guide() {
  return (
    <div className="d-flex flex-column">
      <h1>Guide</h1>
      <div>
        <Figure img={ExImg} caption="서버 생성" />
      </div>
      <div>
        <Figure img={ExImg} caption="서버 관리" />
      </div>
      <div>
        <Figure img={ExImg} caption="홈페이지 생성" />
      </div>
      <div>
        <Figure img={ExImg} caption="홈페이지 관리" />
      </div>
    </div>
  );
};